/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FrameworkCoverageDto
 */
export interface FrameworkCoverageDto {
    /**
     * 
     * @type {string}
     * @memberof FrameworkCoverageDto
     */
    frameworkSlug?: string;
    /**
     * 
     * @type {string}
     * @memberof FrameworkCoverageDto
     */
    shortName?: string;
    /**
     * 
     * @type {number}
     * @memberof FrameworkCoverageDto
     */
    covered?: number;
    /**
     * 
     * @type {number}
     * @memberof FrameworkCoverageDto
     */
    total?: number;
    /**
     * 
     * @type {number}
     * @memberof FrameworkCoverageDto
     */
    coveragePct?: number;
    /**
     * 
     * @type {number}
     * @memberof FrameworkCoverageDto
     */
    avgMaturity?: number;
}

/**
 * Check if a given object implements the FrameworkCoverageDto interface.
 */
export function instanceOfFrameworkCoverageDto(value: object): value is FrameworkCoverageDto {
    return true;
}

export function FrameworkCoverageDtoFromJSON(json: any): FrameworkCoverageDto {
    return FrameworkCoverageDtoFromJSONTyped(json, false);
}

export function FrameworkCoverageDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): FrameworkCoverageDto {
    if (json == null) {
        return json;
    }
    return {
        
        'frameworkSlug': json['frameworkSlug'] == null ? undefined : json['frameworkSlug'],
        'shortName': json['shortName'] == null ? undefined : json['shortName'],
        'covered': json['covered'] == null ? undefined : json['covered'],
        'total': json['total'] == null ? undefined : json['total'],
        'coveragePct': json['coveragePct'] == null ? undefined : json['coveragePct'],
        'avgMaturity': json['avgMaturity'] == null ? undefined : json['avgMaturity'],
    };
}

export function FrameworkCoverageDtoToJSON(json: any): FrameworkCoverageDto {
    return FrameworkCoverageDtoToJSONTyped(json, false);
}

export function FrameworkCoverageDtoToJSONTyped(value?: FrameworkCoverageDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'frameworkSlug': value['frameworkSlug'],
        'shortName': value['shortName'],
        'covered': value['covered'],
        'total': value['total'],
        'coveragePct': value['coveragePct'],
        'avgMaturity': value['avgMaturity'],
    };
}

